import { Col, Row } from 'react-bootstrap';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import styles from './CustomDatePicker.module.scss';

interface IProps extends ReactDatePickerProps {
  label?: string;
  errors?: { isShow: boolean; message: string }[];
  textAlign?: 'left' | 'center';
}

const CustomDatePicker = (props: IProps) => {
  const { textAlign = 'center' } = props;
  return (
    <Row>
      <Col>
        {props.label && (
          <label className={[styles.label].join(' ')}>
            {props.label}{' '}
            {props.required && <span className='text-danger'>*</span>}
          </label>
        )}
        <DatePicker
          className={[styles.datePicker, styles[textAlign], 'w-100'].join(' ')}
          {...props}
        />
        {props.errors?.map(
          (error, index) =>
            error.isShow && (
              <p key={index} className={[styles.error].join(' ')}>
                {error.message}
              </p>
            )
        )}
      </Col>
    </Row>
  );
};

export default CustomDatePicker;
